// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Playfair Display', 'Playfair Display Fallback'","fontStyle":"normal"},"className":"__className_0a80b4","variable":"__variable_0a80b4"};